const exitPopup = () => {
	$(document).ready(function () {
		let showPopup = true;
		if ($('#js-exit-popup').length == 1) {
			var exitPopupWindow = $('#js-exit-popup');
			var cookie = parseInt(sessionStorage.getItem('exit_popup_close'));
			if (cookie >= 0) {
				cookie = cookie + 7200;
			} else {
				cookie = 0;
			}
			if ($(window).width() >= 1024) {
				$(document).bind("mouseleave", function (e) {
					var currentTime = parseInt(Date.now() / 1000);
					if (cookie < currentTime && showPopup) {
						if (e.pageY - $(window).scrollTop() <= 1) {
							exitPopupWindow.show();
							var closeTime = parseInt(Date.now() / 1000);
							sessionStorage.setItem('exit_popup_close', closeTime);
							showPopup = false;
						}
					}
				});
				
			} else {
				/* START: on scroll up */
				var lastScrollTop = 0;
				
				function scroll() {
					if (!exitPopupWindow.hasClass('active')) {
						var st = window.pageYOffset || document.documentElement.scrollTop;
						if (st <= lastScrollTop) {
							var currentTime = parseInt(Date.now() / 1000);
							if (cookie < currentTime && showPopup) {
								exitPopupWindow.show();
								exitPopupWindow.addClass('active');
								var closeTime = parseInt(Date.now() / 1000);
								sessionStorage.setItem('exit_popup_close', closeTime);
								showPopup = false;
							}
						}
						
						lastScrollTop = st <= 0 ? 0 : st;
					}
				}
				
				document.onscroll = scroll;
				/* END: on scroll up */
				
				/* START: on back button */
				if (window.history && window.history.pushState) {
					$(window).on('popstate', function (e) {
						window.history.pushState('forward', null, './#ep');
						if (!exitPopupWindow.hasClass('active')) {
							var currentTime = parseInt(Date.now() / 1000);
							if (cookie < currentTime) {
								exitPopupWindow.show();
								exitPopupWindow.addClass('active');
								var closeTime = parseInt(Date.now() / 1000);
								sessionStorage.setItem('exit_popup_close', closeTime);
								showPopup = false;
							}
						}
					});
				}
			}
			$('#js-exit-popup-close').click(function (e) {
				e.preventDefault();
				$('#js-exit-popup').hide();
			});
		}
	});
};

export {exitPopup};




// WEBPACK FOOTER //
// ../components/exitPopup/exitPopup.js